import Raven from 'raven-js'

export default {
  notifyResponse (errorResponse) {
    Raven.captureException(new Error(JSON.stringify(errorResponse)))
  }
}



// WEBPACK FOOTER //
// ./src/services/errors.js